<div class="grid grid-cols-12 gap-6">
  <!-- Stats Cards -->
  <div class="col-span-12 lg:col-span-3">
    <app-agents-stats-widget 
      [durationSeconds]="stats.avgRunDurationSeconds" 
      [loading]="loading">
    </app-agents-stats-widget>
  </div>

  <div class="col-span-12 lg:col-span-3">
    <app-tasks-stats-widget 
      [count]="stats.totalTasks" 
      [loading]="loading">
    </app-tasks-stats-widget>
  </div>

  <div class="col-span-12 lg:col-span-3">
    <app-executions-stats-widget 
      [count]="stats.totalJobExecutions" 
      [lastExecutionTime]="stats.lastExecutionTime"
      [loading]="loading">
    </app-executions-stats-widget>
  </div>

  <div class="col-span-12 lg:col-span-3">
    <app-running-jobs-widget 
      [count]="stats.runningJobs" 
      [loading]="loading">
    </app-running-jobs-widget>
  </div>

  <!-- Left Column: Agent Status and Success Rate -->
  <div class="col-span-12 lg:col-span-5">
    <div class="space-y-6 h-full">
      <!-- Agent Status -->
      <div class="flex-1">
        <app-agent-status-widget 
          [agents]="agents"
          [loading]="loading">
        </app-agent-status-widget>
      </div>
      
      <!-- Success Rate -->
      <div class="flex-1">
        <app-success-rate-widget 
          [completedRuns]="stats.todayStats.completed"
          [failedRuns]="stats.todayStats.failed"
          [loading]="loading">
        </app-success-rate-widget>
      </div>
    </div>
  </div>

  <!-- Right Column: Tasks Chart -->
  <div class="col-span-12 lg:col-span-7">
    <div class="h-full">
      <app-tasks-chart-widget 
        [data]="tasksChartData"
        [loading]="loading">
      </app-tasks-chart-widget>
    </div>
  </div>
</div>
